import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// STICKY captions: each line holds until the next begins. fromSec spaced ~5-6s apart.
// Grounded in src/lib/data-lifecycle/gdpr-export.ts + supabase/migrations/001_initial_schema.sql.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.4, caption: "GDPR says a user can ask for everything you know about them. I wrote that as one function." },
];

export const PROBLEM: ScriptLine[] = [
  { scene: "problem", fromSec: 0.4, caption: "Article 20 — the right to data portability. The user owns their data and can take it elsewhere." },
  { scene: "problem", fromSec: 6.5, caption: "So exportUserData(userId, tenantId) walks the database and returns one structured JSON object." },
];

export const SHAPE: ScriptLine[] = [
  { scene: "shape", fromSec: 0.4, caption: "It gathers five things: the user profile, their tenant memberships, and every chat session." },
  { scene: "shape", fromSec: 6.2, caption: "Inside each session, every message — role, content, timestamp — plus the knowledge sources they created." },
  { scene: "shape", fromSec: 12, caption: "That is the whole person, as the system actually stores them. Nothing hand-waved." },
];

export const EXCLUDE: ScriptLine[] = [
  { scene: "exclude", fromSec: 0.4, caption: "The interesting part is what it refuses to include. Two things are deliberately left out." },
  { scene: "exclude", fromSec: 6, caption: "Connection credentials — the connection_settings column on knowledge sources — never leave the system." },
  { scene: "exclude", fromSec: 12, caption: "And raw document chunks: that content belongs to the knowledge base, not to the user." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.5, caption: "The exclusion isn't a filter you can forget. Every query names its columns explicitly." },
  { scene: "code", fromSec: 6.2, caption: "connection_settings is never in a select list — so a credential can't leak by accident." },
  { scene: "code", fromSec: 12.5, caption: "Security by what you never read, not by what you remember to strip out afterward." },
];

export const HONEST: ScriptLine[] = [
  { scene: "honest", fromSec: 0.4, caption: "Honest status: this is the export function. There's no HTTP endpoint or download button wired to it yet." },
  { scene: "honest", fromSec: 6.5, caption: "It's a solo build-in-public project — the logic is done and auditable; the UI is the next piece." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.4, caption: "Data portability as one readable function — and the security is in what it chooses not to export." },
  { scene: "outro", fromSec: 5.4, caption: "Next: how I map a user's intent to the right agent skill — without an LLM." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
